import { Pressable, StyleSheet, View } from 'react-native';
import { Mic, Send } from 'lucide-react-native';
import { tokens } from '../../theme/tokens';
import { AppInput } from '../ui/AppInput';

type AssistantInputBarProps = {
  value: string;
  placeholder: string;
  isRecording: boolean;
  onChangeText: (value: string) => void;
  onSend: () => void;
  onStartVoice: () => void;
  onEndVoice: () => void;
};

export function AssistantInputBar({
  value,
  placeholder,
  isRecording,
  onChangeText,
  onSend,
  onStartVoice,
  onEndVoice,
}: AssistantInputBarProps) {
  return (
    <View style={styles.wrapper}>
      <Pressable
        accessibilityRole="button"
        onPressIn={onStartVoice}
        onPressOut={onEndVoice}
        style={[styles.iconButton, isRecording ? styles.recordingButton : null]}
      >
        <Mic size={18} color={isRecording ? tokens.colors.white : tokens.colors.primary} />
      </Pressable>
      <AppInput
        value={value}
        onChangeText={onChangeText}
        placeholder={isRecording ? '正在录音，松开发送...' : placeholder}
        style={styles.input}
      />
      <Pressable accessibilityRole="button" onPress={onSend} style={styles.sendButton}>
        <Send size={18} color={tokens.colors.white} />
      </Pressable>
    </View>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    minHeight: 56,
    flexDirection: 'row',
    alignItems: 'center',
    gap: tokens.spacing.sm,
  },
  iconButton: {
    width: 44,
    height: 44,
    borderRadius: 22,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: tokens.colors.surfaceMuted,
  },
  recordingButton: {
    backgroundColor: tokens.colors.primary,
  },
  input: {
    flex: 1,
  },
  sendButton: {
    width: 44,
    height: 44,
    borderRadius: 22,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: tokens.colors.primary,
  },
});
